/* eslint-disable prefer-const */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-unused-vars */
/* eslint-disable no-else-return */
import React from "react";
import moment from "moment";
import { ListGroupItem } from "reactstrap";
import { Bookmark } from "lucide-react";
import { humanDateFormat } from "../../../../config/constants";
import useFetcher from "../../../hooks/useFetcher";
import { fetchMessageTicketing } from "../../../services/messageTicketingService";
import { CustomListGroupItem } from "./styles";

const ItemListConversation = ({ item, ticket, handleConversationSelected, key }) => {
  const [conversation, isLoadingConversation] = useFetcher(fetchMessageTicketing, [ticket.itemId, item.id]);
  const isEmail = (email) => /\S+@\S+/.test(email);
  const getEmailCreador = () => {
    const posiblesEmails = [ticket.CreadoPara.titulo, ticket.CreadoPara.title, ticket.CreadoPara.email2];
    const email = posiblesEmails.find((d) => isEmail(d));
    return email;
  };
  const getEmailColaborador = (colaborador) => {
    const posiblesEmails = [colaborador.titulo, colaborador.email2];
    const email = posiblesEmails.find((d) => isEmail(d));
    return email;
  };

  return (
    <>
      {!isLoadingConversation && (
        <CustomListGroupItem key={key} className="border-bottom px-2 py-3" onClick={(event) => handleConversationSelected(event, item)}>
          <div className="d-flex flex-column align-items-start justify-content-end">
            {conversation.colaboradores.length === 0 ? <div className="name"> {getEmailCreador()} </div> : null}
            {conversation.colaboradores.map((c) => {
              return <div className="name">{getEmailColaborador(c)}</div>;
            })}
            <div className="py-1 font-weight-bold text-left"> {item.subject} </div>
          </div>
          <div className="d-flex flex-column align-items-end justify-content-end">
            {item.isRoot && (
              <small className="mb-3">
                <Bookmark size="20" color="#f0292a" />
              </small>
            )}
            <small> {item.updatedAt ? moment.utc(item.updatedAt).format(humanDateFormat) : ""} </small>
          </div>
        </CustomListGroupItem>
      )}
    </>
  );
};

export default ItemListConversation;
